import { FC } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { IRouterList } from '../../types/IRouterList';
import React from 'react';
import RouteList from './RouterList';

const Routers: FC = () => {
    const Default = RouteList[0] && RouteList[0].component;
    const defaultPath = RouteList[0] && RouteList[0].path;
    return (
        <Routes>
            {RouteList.map((route: IRouterList) => (
                <Route key={route.code} path={route.path || ''} element={<route.component />}></Route>
            ))}
            <Route path="*" element={defaultPath ? <Navigate to={defaultPath} /> : Default && <Default />} />
        </Routes>
    );
};

export default Routers;
